import * as _ from 'lodash';
import {Serializable} from '../../deserialize.service';

export class GroupInvocesRequest implements Serializable<GroupInvocesRequest> {
    payerCustomerId: number;
    payerPartnerId: number;

    deserialize(input) {
        if (_.isNil(input)) {
            return undefined;
        }

        this.payerCustomerId = input.payerCustomerId;
        this.payerPartnerId = input.payerPartnerId;
        return this;
    }
}
